export default function CsharpMethodOverriding() {
  return (
    <h2>Csharp Method Overriding</h2>
  );
}
